import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Media,
  Collapse,
  Input,
  Label,
  Button,
  UncontrolledTooltip,
  TabPane,
} from "reactstrap"
import { Link } from "react-router-dom";
import "toastr/build/toastr.min.css"
import SelectCountry from "../../components/Filter/SelectCountry";

function SearchEntity({
    filterValidation,
    toggle,
    isOpen,
    searchList,
    starOrUnstar_Search,
    hideOrUnhide_Search,
    chkAllFlag_Search,
    totalPageSearch,
    curPageSearch,
    setCurPageSearch,
    entityChkSearch,
    setConfirmMsg,
    setConfirmAlert,
    entityCheckSearch,
    togContactsScreen,
    unsecuredCopyToClipboard,
    showSuccessCopyToast,
    viewContactsSearchList
}) {
    return (
        <TabPane tabId="Search">
            <Row>
                <Col lg={12}>

                    <Card>
                        <Link onClick={toggle} className="text-dark" to="#">
                            <div className="p-4">
                                <Media className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-3">
                                        <i className="uil uil-search text-primary h2"></i>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                        <h5 className="font-size-16 mb-1">Search</h5>
                                        <p className="text-muted mb-0">Search for entities</p>
                                    </div>
                                    <i className="uil uil-filter font-size-24 text-muted"></i>
                                </Media>
                            </div>
                        </Link>
                        <Collapse isOpen={isOpen}>
                            <div className="p-4 border-top">
                                <div>
                                    <Row className="mb-3 align-items-center">
                                        <label htmlFor="entityStatusSearch" className="col-md-3 col-form-label">
                                            Entity status
                                        </label>
                                        <div className="col-md-4 d-flex" style={{ justifyContent: "space-between" }}>
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input"
                                                    id="onlyNonHiddenSearch"
                                                    name="entityStatusSearch"
                                                    onChange={filterValidation.handleChange}
                                                    value="onlyNonHidden"
                                                    checked={filterValidation.values.entityStatusSearch === "onlyNonHidden"}
                                                />
                                                <Label className="form-check-label" htmlFor="onlyNonHiddenSearch">
                                                    Only non-hidden
                                                </Label>
                                            </div>
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input"
                                                    id="onlyStarredSearch"
                                                    name="entityStatusSearch"
                                                    onChange={filterValidation.handleChange}
                                                    value="onlyStarred"
                                                    checked={filterValidation.values.entityStatusSearch === "onlyStarred"}
                                                />
                                                <Label className="form-check-label" htmlFor="onlyStarredSearch">
                                                    Only Starred
                                                </Label>
                                            </div>
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input"
                                                    id="onlyStarredAndNonHiddenSearch"
                                                    name="entityStatusSearch"
                                                    onChange={filterValidation.handleChange}
                                                    value="onlyStarredNonHidden"
                                                    checked={filterValidation.values.entityStatusSearch === "onlyStarredNonHidden"}
                                                />
                                                <Label className="form-check-label" htmlFor="onlyStarredAndNonHiddenSearch">
                                                    Only starred and non-hidden
                                                </Label>
                                            </div>
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input"
                                                    id="onlyHiddenSearch"
                                                    name="entityStatusSearch"
                                                    onChange={filterValidation.handleChange}
                                                    value="onlyHidden"
                                                    checked={filterValidation.values.entityStatusSearch === "onlyHidden"}
                                                />
                                                <Label className="form-check-label" htmlFor="onlyHiddenSearch">
                                                    Only Hidden
                                                </Label>
                                            </div>
                                            <div className="form-check">
                                                <input type="radio" className="form-check-input"
                                                    id="entityStatusAllSearch"
                                                    name="entityStatusSearch"
                                                    onChange={filterValidation.handleChange}
                                                    value=""
                                                    checked={filterValidation.values.entityStatusSearch === ""}
                                                />
                                                <Label className="form-check-label" htmlFor="entityStatusAllSearch">
                                                    All
                                                </Label>
                                            </div>
                                        </div>
                                    </Row>
                                    <Row className="mb-3">
                                        <label htmlFor="searchName" className="col-md-3 col-form-label">
                                            Name of holder or representative
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Name of holder or representative"
                                                id="searchName"
                                                name="searchName"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.searchName}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageSearch(1);
                                                        filterValidation.setFieldValue("curPageSearch", 1);
                                                        filterValidation.setFieldValue("submitType", "viewSearch");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>

                                    <Row className="mb-3">
                                        <label htmlFor="searchDomain" className="col-md-3 col-form-label">
                                            Domain
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Domain"
                                                id="searchDomain"
                                                name="searchDomain"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.searchDomain}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageSearch(1);
                                                        filterValidation.setFieldValue("curPageSearch", 1);
                                                        filterValidation.setFieldValue("submitType", "viewSearch");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>

                                    <SelectCountry
                                        formik={filterValidation}
                                        componentName='SearchEntity'
                                    />

                                    <Row className="mb-3">
                                        <label htmlFor="searchAddress" className="col-md-3 col-form-label">
                                            Address
                                        </label>
                                        <div className="col-md-3">
                                            <Input className="form-control"
                                                type="text"
                                                placeholder="Address"
                                                id="searchAddress"
                                                name="searchAddress"
                                                onChange={filterValidation.handleChange}
                                                value={filterValidation.values.searchAddress}
                                                onKeyPress={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setCurPageSearch(1);
                                                        filterValidation.setFieldValue("curPageSearch", 1);
                                                        filterValidation.setFieldValue("submitType", "viewSearch");
                                                        filterValidation.handleSubmit(filterValidation.values);
                                                    }
                                                }}
                                            /></div>
                                    </Row>

                                    <Row className="mb-3">
                                        <span className="col-md-3">
                                            <Button type="button" color="primary" outline className="waves-effect waves-light" id="excelSearch"
                                                onClick={() => {
                                                    filterValidation.setFieldValue("submitType", "excelSearch");
                                                    filterValidation.handleSubmit(filterValidation.values);
                                                }}
                                            >Download excel
                                            </Button>
                                            <UncontrolledTooltip placement="top" target="excelSearch">
                                                Download Excel limit 1,000 rows
                                            </UncontrolledTooltip>
                                        </span>
                                        <div className="col-md-3"></div>
                                        <Col md={3}>
                                            <button type="button" className="waves-effect waves-light btn btn-primary" style={{ width: '148.58px' }}
                                                onClick={() => {
                                                    setCurPageSearch(1);
                                                    filterValidation.setFieldValue("curPageSearch", 1);
                                                    filterValidation.setFieldValue("submitType", "viewSearch");
                                                    filterValidation.handleSubmit(filterValidation.values);
                                                }}
                                            >Search
                                            </button>
                                        </Col>
                                    </Row>

                                </div>
                            </div>
                        </Collapse>
                    </Card>
                </Col>
            </Row>


            {searchList && searchList.length ?
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="text-muted mb-0">
                                    <Row className="mb-3">
                                        <span className="col-md-6 button-items">
                                            <Button type="button" color="primary" outline className="waves-effect waves-light"
                                                onClick={() => {
                                                    if (entityChkSearch()) {
                                                        filterValidation.setFieldValue("submitType", starOrUnstar_Search + "Search");
                                                        setConfirmMsg("Are you sure you want to " + starOrUnstar_Search.toLowerCase() + " the selected entity?");
                                                        setConfirmAlert(true);
                                                    }
                                                }}
                                            >{starOrUnstar_Search} entity
                                            </Button>
                                            <Button type="button" color="primary" outline className="waves-effect waves-light"
                                                onClick={() => {
                                                    if (entityChkSearch()) {
                                                        filterValidation.setFieldValue("submitType", hideOrUnhide_Search + "Search");
                                                        setConfirmMsg("Are you sure you want to " + hideOrUnhide_Search.toLowerCase() + " the selected entity?");
                                                        setConfirmAlert(true);
                                                    }
                                                }}
                                            >{hideOrUnhide_Search} entity
                                            </Button>
                                        </span>
                                    </Row>
                                </CardTitle>
                                <div className="table-responsive">
                                    <Table className="table mb-0">
                                        <thead>
                                            <tr>
                                                <th style={{ verticalAlign: "middle", textAlign: "center" }}><input type="checkbox" checked={chkAllFlag_Search} onClick={(e) => entityCheckSearch("chkAll", e)} /></th>
                                                <th>Entity</th>
                                                <th>Address</th>
                                                <th>Domain</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                searchList.map((entity, entityIdx) => {
                                                    return (
                                                        <tr key={entityIdx}>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <input type="checkbox"
                                                                    checked={entity.checked}
                                                                    onClick={(e) => entityCheckSearch(entityIdx, e)}
                                                                />
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <div className="d-flex gap-2">
                                                                    <Link to="#" className={entity.starred ? "text-warning" : "text-muted"}
                                                                        onClick={(e) => {
                                                                            filterValidation.setFieldValue("submitType", entity.starred ? "UnstarSearch_" + entity.targetGroupNo : "StarSearch_" + entity.targetGroupNo)
                                                                            filterValidation.handleSubmit(filterValidation.values);
                                                                        }}>
                                                                        <i className="uil uil-star font-size-16" id={"StarredSearch_" + entityIdx}></i>
                                                                        <UncontrolledTooltip placement="top" target={"StarredSearch_" + entityIdx}>
                                                                            {entity.starred ? "Remove from starred" : "Star"}
                                                                        </UncontrolledTooltip>
                                                                    </Link>
                                                                    <Link to="#" className={entity.hidden ? "text-danger" : "text-muted"}
                                                                        onClick={(e) => {
                                                                            filterValidation.setFieldValue("submitType", entity.hidden ? "UnhideSearch_" + entity.targetGroupNo : "HideSearch_" + entity.targetGroupNo)
                                                                            filterValidation.handleSubmit(filterValidation.values);
                                                                        }}>
                                                                        <i className="uil uil-eye-slash font-size-16" id={"searchHidden_" + entityIdx}></i>
                                                                        <UncontrolledTooltip placement="top" target={"searchHidden_" + entityIdx}>
                                                                            {entity.hidden ? "Unhide" : "Hide"}
                                                                        </UncontrolledTooltip>
                                                                    </Link>
                                                                    <Link to="#"
                                                                        className={entity.unsubscribeYn != null && entity.unsubscribeYn == 'Y' ? "text-danger"
                                                                            : entity.memberConfirmEmlYn === "upToDate" ? "text-success"
                                                                                : entity.memberConfirmEmlYn === 'Y' ? "text-primary"
                                                                                    : entity.suggestEmlYn === 'Y' ? "text-warning"
                                                                                        : "text-danger"}
                                                                        onClick={() => { togContactsScreen(entity.targetGroupNo) }} >{entity.targetGroupName}</Link>
                                                                    <Link to="#" id={"copy_entity_search_" + entityIdx}
                                                                        onClick={() => {
                                                                            if (window.isSecureContext && navigator.clipboard) {
                                                                                navigator.clipboard.writeText(entity.targetGroupName);
                                                                            } else {
                                                                                // console.log('old copy clipboard!');
                                                                                unsecuredCopyToClipboard(entity.targetGroupName, "copy_entity_search_" + entityIdx);
                                                                            }
                                                                            showSuccessCopyToast();
                                                                        }}>
                                                                        <i className="uil uil-copy-alt font-size-22 text-secondary"></i>
                                                                    </Link>
                                                                    <UncontrolledTooltip placement="top" target={"copy_entity_search_" + entityIdx}>
                                                                        Copy entity to clipboard
                                                                    </UncontrolledTooltip>
                                                                </div>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <div className="d-flex gap-2 vertical-align-center">
                                                                    {
                                                                        entity.contactsDetailList.length > 0 && entity.contactsDetailList.map((contactsDetail, contactsDetailIdx) => {
                                                                            return (
                                                                                <>{contactsDetail.country + " " + contactsDetail.address}<br /></>
                                                                            )
                                                                        })
                                                                    }
                                                                    {
                                                                        entity.contactsDetailList.length == 1 && entity.contactsDetailList[0].seq == null && entity.pctEntityDetailList.map((contactsDetail, contactsDetailIdx) => {
                                                                            return (
                                                                                <>{contactsDetail.country + " " + contactsDetail.address}<br /></>
                                                                            )
                                                                        })
                                                                    }
                                                                    {
                                                                        entity.contactsDetailList.length > 0 &&
                                                                        <>
                                                                            <Link to="#" id={"copy_address_search_" + entityIdx}
                                                                                onClick={() => {
                                                                                    let copy_address = "";
                                                                                    entity.contactsDetailList.length > 0 && entity.contactsDetailList.map((contactsDetail, contactsDetailIdx) => {
                                                                                        copy_address += contactsDetail.country + " " + contactsDetail.address + "\n";
                                                                                    })

                                                                                    if (entity.contactsDetailList.length == 1 && entity.contactsDetailList[0].seq == null) {
                                                                                        entity.pctEntityDetailList.length > 0 && entity.pctEntityDetailList.map((contactsDetail, contactsDetailIdx) => {
                                                                                            copy_address += contactsDetail.country + " " + contactsDetail.address + "\n";
                                                                                        })
                                                                                    }

                                                                                    if (window.isSecureContext && navigator.clipboard) {
                                                                                        navigator.clipboard.writeText(copy_address);
                                                                                    } else {
                                                                                        unsecuredCopyToClipboard(copy_address, "copy_address_search_" + entityIdx);
                                                                                    }
                                                                                    showSuccessCopyToast();
                                                                                }}>
                                                                                <i className="uil uil-copy-alt font-size-22 text-secondary"></i>
                                                                            </Link>
                                                                            <UncontrolledTooltip placement="top" target={"copy_address_search_" + entityIdx}>
                                                                                Copy address to clipboard
                                                                            </UncontrolledTooltip>
                                                                        </>
                                                                    }
                                                                </div>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle" }}>
                                                                <div className="d-flex gap-2">
                                                                    {entity.unsubscribeYn != null && entity.unsubscribeYn == 'Y' ? "Unsubscribed" : entity.domain}
                                                                    {
                                                                        entity.domain && <>
                                                                            <Link to="#" id={"copy_domain_search_" + entityIdx}
                                                                                onClick={() => {
                                                                                    if (window.isSecureContext && navigator.clipboard) {
                                                                                        navigator.clipboard.writeText(entity.unsubscribeYn != null && entity.unsubscribeYn == 'Y' ? "Unsubscribed" : entity.domain);
                                                                                    } else {
                                                                                        unsecuredCopyToClipboard(entity.unsubscribeYn != null && entity.unsubscribeYn == 'Y' ? "Unsubscribed" : entity.domain, "copy_domain_search_" + entityIdx);
                                                                                    }
                                                                                    showSuccessCopyToast();
                                                                                }}>
                                                                                <i className="uil uil-copy-alt font-size-22 text-secondary"></i>
                                                                            </Link>
                                                                            <UncontrolledTooltip placement="top" target={"copy_domain_search_" + entityIdx}>
                                                                                Copy domain to clipboard
                                                                            </UncontrolledTooltip>
                                                                        </>
                                                                    }
                                                                    
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                <div className="d-flex page-nation-align">
                                    <span className="d-flex align-items-center gap-2">
                                        <label
                                            htmlFor="perPageSearch"
                                            className="d-none d-sm-block"
                                        >
                                            Entries per page
                                        </label>
                                        <div style={{ width: "100px" }} className="d-none d-sm-block">
                                            <select
                                                className="form-select"
                                                name="perPageSearch"
                                                onChange={e => { viewContactsSearchList(null, 1, e.target.value); }}
                                                value={filterValidation.values.perPageSearch}
                                            >
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="40">40</option>
                                                <option value="50">50</option>
                                            </select>
                                        </div>
                                    </span>
                                    <span className="d-flex align-items-center gap-2">
                                        <div className="d-flex gap-1">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsSearchList(null, 1); }}
                                                disabled={(filterValidation.values.curPageSearch == 1)}
                                            >
                                                {"<<"}
                                            </Button>
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsSearchList(null, Number(filterValidation.values.curPageSearch) - 1); }}
                                                disabled={(filterValidation.values.curPageSearch == 1)}
                                            >
                                                {"<"}
                                            </Button>
                                        </div>
                                        Page{" "}
                                        <strong>
                                            {filterValidation.values.curPageSearch} of {totalPageSearch}
                                        </strong>
                                        <Input
                                            type="number"
                                            min={1}
                                            style={{ width: 70 }}
                                            max={totalPageSearch}
                                            name="curPageSearch"
                                            defaultValue={filterValidation.values.curPageSearch}
                                            value={curPageSearch}
                                            onChange={(e) => { setCurPageSearch(e.target.value) }}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    viewContactsSearchList(null, e.target.value);
                                                }
                                            }}
                                            className="d-none d-sm-block"
                                        />
                                        <div className="d-flex gap-1">
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsSearchList(null, Number(filterValidation.values.curPageSearch) + 1); }}
                                                disabled={(filterValidation.values.curPageSearch == totalPageSearch)}
                                            >
                                                {">"}
                                            </Button>
                                            <Button
                                                type="button"
                                                color="primary"
                                                onClick={() => { viewContactsSearchList(null, totalPageSearch); }}
                                                disabled={(filterValidation.values.curPageSearch == totalPageSearch)}
                                            >
                                                {">>"}
                                            </Button>
                                        </div>
                                    </span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                : null}
        </TabPane>
    )
}

export default SearchEntity;